import { themeGet } from '../../utils/theme-get.js';
import React__default from 'react';
import styled from 'styled-components';
import Box from '../Box/Box.js';

const RADIUS = {
  none: {
    borderRadius: 0
  },
  sm: {
    borderRadius: 3
  },
  md: {
    borderRadius: 4
  },
  lg: {
    borderRadius: 8
  },
  xl: {
    borderRadius: 16
  },
  xxl: {
    borderRadius: 32
  },
  full: {
    borderRadius: 9999999
  }
};
const ImgWrapper = ({
  children,
  raised = true,
  rounded = 'none'
}) => {
  const radiusSize = RADIUS[rounded];
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    as: "div",
    raised: raised,
    style: {
      '--border-radius': `${radiusSize.borderRadius}px`
    }
  }, /*#__PURE__*/React__default.createElement(Container, {
    style: {
      '--border-radius': `${radiusSize.borderRadius}px`
    }
  }, children));
};
ImgWrapper.displayName = "ImgWrapper";
const Wrapper = styled(Box).withConfig({
  displayName: "ImgWrapper__Wrapper",
  componentId: "sc-xpe288-0"
})(["display:flex;max-width:min-content;border-radius:var(--border-radius);position:relative;filter:", ";margin:0 auto;@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}"], p => p.raised ? `drop-shadow(0px 18px 28px rgba(9, 30, 66, 0.15)) drop-shadow(0px 0px 1px rgba(9, 30, 66, 0.31))` : '', themeGet('breakpoints.0'), themeGet('breakpoints.1'), themeGet('breakpoints.2'), themeGet('breakpoints.3'));
const Container = styled(Box).withConfig({
  displayName: "ImgWrapper__Container",
  componentId: "sc-xpe288-1"
})(["display:flex;justify-content:center;border-radius:var(--border-radius);position:relative;width:350px;img{width:100%;height:100%;display:block;border-radius:var(--border-radius);}@media (min-width:", "){}@media (min-width:", "){width:564px;}@media (min-width:", "){width:768px;}@media (min-width:", "){}"], themeGet('breakpoints.0'), themeGet('breakpoints.1'), themeGet('breakpoints.2'), themeGet('breakpoints.3'));
ImgWrapper.displayName = 'ImgWrapper';
var ImgWrapper$1 = ImgWrapper;

export { ImgWrapper$1 as default };
